import Tippy from '@tippyjs/react';

const Tooltip = ({ text, children, placement, hideBrowserTooltip }: any) => {
  return (
    <Tippy
      content={
        <div title={text}>
          <div className="tooltip-title">{text}</div>
        </div>
      }
      placement={placement}
    >
      <div className={`pck-card-title`} title={hideBrowserTooltip ? null : text}>
        {children ? children : <span title={text}>{text}</span>}
      </div>
    </Tippy>
  );
};

export default Tooltip;
